import logo from './images/logo.png';

export default {
  country: 'dk',
  logo,
  brand: 'Carlsberg',
  availableContactPeriods: ['', '07:00-10:00', '10:00-13:00', '13:00-16:00', '07:00-16:00'],
  availableDeliveryPeriods: ['', '07:00-10:00', '10:00-13:00', '13:00-16:00', '07:00-16:00'],
  tosTermsAndConditionsLink: "https://shop.carlsbergdanmark.dk/Cookiepolitik",
  tosPrivacyPolicyLink: "https://shop.carlsbergdanmark.dk/Privatlivspolitik",
  checkPaymentTermsLink: "https://shop.carlsbergdanmark.dk/-/media/DK/PDFs/CarlsbergOnlineHandelsbetingelser.pdf"
};